import { LazyWafBlockModal } from '#components'

export default defineNuxtPlugin(() => {
  const originalFetch = globalThis.$fetch

  globalThis.$fetch = originalFetch.create({
    async onResponseError({ request, response }) {
      const rayId = response.headers.get('cf-ray')
      const mitigatedHeader = response.headers.get('cf-mitigated')

      const mitigatedValues = [
        'challenge',
        'block',
        'jschallenge',
        'managed-challenge',
      ]
      const isMitigated =
        mitigatedHeader &&
        mitigatedValues.includes(mitigatedHeader.toLowerCase())

      const rayIdRegex = /^[a-fA-F0-9]+-[A-Z]{3}$/
      const isValidRayId = rayId && rayIdRegex.test(rayId)

      if (response.status === 403 && isMitigated) {
        const displayRayId = isValidRayId ? rayId : null
        const overlay = useOverlay()
        const { $datadog } = useNuxtApp()

        const requestUrl =
          typeof request === 'string'
            ? request
            : (request as Request).url || request.toString()

        let cleanUrl = requestUrl
        try {
          const parsed = new URL(requestUrl, window.location.origin)
          cleanUrl =
            parsed.origin === window.location.origin
              ? parsed.pathname
              : `${parsed.origin}${parsed.pathname}`
        } catch {
          // Fallback to unparsed requestUrl if URL parsing fails
        }

        const rawRayId = displayRayId?.split('-')[0]
        const modal = overlay.create(LazyWafBlockModal, {
          props: {
            rayId: rawRayId,
            method:
              typeof request === 'string'
                ? 'GET'
                : (request as Request).method || 'GET',
            url: cleanUrl,
          },
        })
        modal.open()

        if ($datadog) {
          $datadog.addError(new Error('waf_403_block'), {
            rayId: displayRayId || 'Unknown',
            path: cleanUrl,
          })
        }
      }
    },
  })
})
